import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import cx from 'classnames';
import toTitleCase from '@clearscore-group/lib.normalize.title-case';
import useMedia from '@clearscore-group/lib.hooks.use-media';
import { Link } from 'react-router-dom';
import isInternalUrl from '@clearscore-group/lib.helpers.is-internal-url';
import { mediaQuery } from '@clearscore/ui.rainbow.tokens';

/* eslint-disable import/prefer-default-export */
var themes = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  INHERIT: 'INHERIT'
};
var styles$2 = {
  "component": "component--bdjTd",
  "isThemeLight": "isThemeLight--NKfaW",
  "isThemeDark": "isThemeDark--p4VXe",
  "isThemeInherit": "isThemeInherit--CJV4D",
  "isSimpleLink": "isSimpleLink--NCvfj"
};
var removeSubDomain = function removeSubDomain() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return url.split('.').length > 2 ? url.split('.').slice(1).join('.') : url;
};
var getSubDomain = function getSubDomain(url) {
  return url.split('//').length > 1 ? url.split('.').shift() : undefined;
};
var sameOrigin = function sameOrigin(pathname) {
  var hostname = window.location.hostname;
  return removeSubDomain(pathname).includes(removeSubDomain(hostname));
};
var sameSubDomain = function sameSubDomain(pathname) {
  var origin = window.location.origin;
  var linkSubdomain = getSubDomain(pathname);
  if (!linkSubdomain) return true;
  var originSubDomain = getSubDomain(origin);
  var pathnameSubDomain = getSubDomain(pathname);
  if (!originSubDomain || !pathnameSubDomain) return false;
  return originSubDomain.includes(pathnameSubDomain);
};

// always ensure www links start with // (i.e. learn articles)
// if its a link on same domain, then remove http(s) so RR doesn't prefix with `/`
var normalisePath = function normalisePath(pathname) {
  var url = pathname.startsWith('www.') ? "//".concat(pathname) : pathname;
  return sameOrigin(pathname) ? url.replace(/https?:/, '') : url;
};
var getPathname = function getPathname(_ref23) {
  var href = _ref23.href,
    to = _ref23.to;
  if (typeof to === 'string') return to;
  if (typeof to === 'function') return getPathname({
    to: to(window.location)
  });
  if (typeof (to === null || to === void 0 ? void 0 : to.pathname) === 'string') return to.pathname;
  if (typeof href === 'string') return href;
  return '';
};

// note: href is now deprecated please do not use
var TextLink = function TextLink(_ref24) {
  var children = _ref24.children,
    _ref24$theme = _ref24.theme,
    _theme = _ref24$theme === void 0 ? themes.LIGHT : _ref24$theme,
    href = _ref24.href,
    title = _ref24.title,
    _ref24$isNewTab = _ref24.isNewTab,
    _isNewTab = _ref24$isNewTab === void 0 ? false : _ref24$isNewTab,
    onClick = _ref24.onClick,
    _ref24$isSimpleLink = _ref24.isSimpleLink,
    _isSimpleLink = _ref24$isSimpleLink === void 0 ? false : _ref24$isSimpleLink,
    to = _ref24.to,
    ariaLabel = _ref24.ariaLabel;
  var link = normalisePath(getPathname({
    href: href,
    to: to
  }));
  var internalLink = isInternalUrl(link);
  var newTabProps = {
    rel: 'noopener noreferrer',
    target: '_blank'
  };
  var reactRouterSafe = !link.startsWith('#') && sameSubDomain(link); // react-router doesn't like '#' or different sub-domains links
  var linkProps = {
    className: cx(styles$2.component, styles$2["isTheme".concat(toTitleCase(_theme))], _defineProperty({}, styles$2.isSimpleLink, _isSimpleLink)),
    onClick: onClick,
    title: title,
    'aria-label': ariaLabel
  };
  switch (true) {
    case internalLink && reactRouterSafe:
      return /*#__PURE__*/React.createElement(Link, _objectSpread(_objectSpread({}, linkProps), {}, {
        to: to || link
      }, _isNewTab ? newTabProps : {}), children);
    case !link:
      return /*#__PURE__*/React.createElement("button", _objectSpread(_objectSpread({}, linkProps), {}, {
        type: "button"
      }), children);
    case internalLink:
      return /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, linkProps), {}, {
        href: link
      }), children);
    default:
      return /*#__PURE__*/React.createElement("a", _objectSpread(_objectSpread({}, linkProps), {}, {
        href: link || undefined
      }, newTabProps), children);
  }
};
TextLink.themes = themes;
var styles$1 = {
  "component": "component--6UYXH"
};
var TextStrong = function TextStrong(_ref25) {
  var children = _ref25.children;
  return /*#__PURE__*/React.createElement("strong", {
    className: styles$1.component
  }, children);
};
var types = {
  MICRO: 'MICRO',
  TINY: 'TINY',
  MINI: 'MINI',
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE',
  BIG: 'BIG',
  HUGE: 'HUGE',
  MASSIVE: 'MASSIVE',
  JUMBO: 'JUMBO',
  GARGANTUAN: 'GARGANTUAN',
  RIDICULOUS: 'RIDICULOUS'
};
var weights = {
  THIN: 'THIN',
  LIGHT: 'LIGHT',
  BOOK: 'BOOK',
  REGULAR: 'REGULAR',
  MEDIUM: 'MEDIUM',
  BOLD: 'BOLD',
  BLACK: 'BLACK'
};
var spacings = {
  TIGHT: 'TIGHT',
  WIDE: 'WIDE',
  EXPLODED: 'EXPLODED'
};
var tags = {
  DIV: 'div',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span',
  LABEL: 'label',
  LEGEND: 'legend'
};
var presets = {
  J1: {
    type: [types.GARGANTUAN, types.RIDICULOUS],
    weight: weights.THIN,
    breakpoints: [null, mediaQuery['rnb-mq-medium']]
  },
  J2: {
    type: [types.JUMBO, types.GARGANTUAN],
    weight: weights.THIN,
    breakpoints: [null, mediaQuery['rnb-mq-medium']]
  },
  J3: {
    type: [types.MASSIVE, types.JUMBO],
    weight: weights.THIN,
    breakpoints: [null, mediaQuery['rnb-mq-medium']]
  },
  J4: {
    type: [types.BIG, types.MASSIVE],
    breakpoints: [null, mediaQuery['rnb-mq-medium']]
  },
  H1: {
    type: [types.BIG, types.HUGE],
    tag: tags.H1,
    breakpoints: [null, mediaQuery['rnb-mq-medium']]
  },
  H2: {
    type: [types.MEDIUM, types.LARGE],
    tag: tags.H2,
    weight: weights.BOLD,
    breakpoints: [null, mediaQuery['rnb-mq-medium']]
  },
  H3: {
    type: types.SMALL,
    weight: weights.BOLD,
    tag: tags.H3
  },
  H4: {
    type: types.MINI,
    weight: weights.BOLD,
    tag: tags.H4
  },
  H5: {
    type: types.MINI,
    spacing: spacings.WIDE,
    tag: tags.H5,
    isUppercase: true
  },
  H6: {
    type: types.TINY,
    weight: weights.BOLD,
    spacing: spacings.WIDE,
    tag: tags.H6,
    isUppercase: true
  },
  BODY1: {
    type: types.SMALL,
    tag: tags.P
  },
  BODY2: {
    type: types.MINI,
    tag: tags.P
  },
  BODY3: {
    type: types.MINI,
    weight: weights.BOLD,
    tag: tags.P
  },
  BODY4: {
    type: types.TINY,
    tag: tags.P
  },
  BODY5: {
    type: types.TINY,
    weight: weights.BOLD,
    tag: tags.P
  },
  BODY6: {
    type: types.MICRO,
    spacing: spacings.WIDE,
    tag: tags.P
  },
  BUTTON1: {
    type: types.MINI,
    weight: weights.BOLD,
    spacing: spacings.WIDE
  },
  BUTTON2: {
    type: types.TINY,
    weight: weights.BOLD,
    spacing: spacings.WIDE
  },
  CAPTION: {
    type: types.TINY,
    spacing: spacings.WIDE
  },
  OVERLINE: {
    type: types.TINY,
    spacing: spacings.EXPLODED,
    isUppercase: true
  },
  LINK: {
    type: types.MINI,
    weight: weights.BOLD
  }
};
var styles = {
  "component": "component--3RXTZ",
  "isTypeMicro": "isTypeMicro--jMXBH",
  "isTypeTiny": "isTypeTiny--sNAcZ",
  "isTypeMini": "isTypeMini--nsXDZ",
  "isTypeSmall": "isTypeSmall--j-ZTR",
  "isTypeMedium": "isTypeMedium--edNdC",
  "isTypeLarge": "isTypeLarge--YKQ9l",
  "isTypeBig": "isTypeBig--CnInX",
  "isTypeHuge": "isTypeHuge--lF4em",
  "isTypeMassive": "isTypeMassive---lb60",
  "isTypeJumbo": "isTypeJumbo--NTmXO",
  "isTypeGargantuan": "isTypeGargantuan--DPGWb",
  "isTypeRidiculous": "isTypeRidiculous--Ke9Xj",
  "isWeightThin": "isWeightThin--RYdR3",
  "isWeightLight": "isWeightLight--Yes5K",
  "isWeightBook": "isWeightBook--4aB31",
  "isWeightRegular": "isWeightRegular--TNxZp",
  "isWeightMedium": "isWeightMedium--sWfsp",
  "isWeightBold": "isWeightBold--R2keQ",
  "isWeightBlack": "isWeightBlack--0vreC",
  "isSpacingTight": "isSpacingTight--bxQKv",
  "isSpacingWide": "isSpacingWide--ywQws",
  "isSpacingExploded": "isSpacingExploded--XvVRU",
  "isUppercase": "isUppercase--pUKn9",
  "isItalic": "isItalic--D9yOy"
};
var _excluded = ["children", "type", "weight", "spacing", "tag", "breakpoints", "isItalic", "isUppercase", "isLink", "isSimpleLink", "dataId"],
  _excluded2 = ["tag"],
  _excluded3 = ["tag"],
  _excluded4 = ["tag"],
  _excluded5 = ["tag"],
  _excluded6 = ["tag"],
  _excluded7 = ["tag"],
  _excluded8 = ["tag"],
  _excluded9 = ["tag"],
  _excluded10 = ["tag"],
  _excluded11 = ["tag"],
  _excluded12 = ["tag"],
  _excluded13 = ["tag"],
  _excluded14 = ["tag"],
  _excluded15 = ["tag"],
  _excluded16 = ["tag"],
  _excluded17 = ["tag"],
  _excluded18 = ["tag"],
  _excluded19 = ["tag"],
  _excluded20 = ["tag"],
  _excluded21 = ["tag"],
  _excluded22 = ["tag"];
var Text = function Text(_ref) {
  var _cx2;
  var children = _ref.children,
    type = _ref.type,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? weights.REGULAR : _ref$weight,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? spacings.TIGHT : _ref$spacing,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? tags.DIV : _ref$tag,
    _ref$breakpoints = _ref.breakpoints,
    breakpoints = _ref$breakpoints === void 0 ? [] : _ref$breakpoints,
    _ref$isItalic = _ref.isItalic,
    isItalic = _ref$isItalic === void 0 ? false : _ref$isItalic,
    _ref$isUppercase = _ref.isUppercase,
    isUppercase = _ref$isUppercase === void 0 ? false : _ref$isUppercase,
    _ref$isLink = _ref.isLink,
    isLink = _ref$isLink === void 0 ? false : _ref$isLink,
    _ref$isSimpleLink = _ref.isSimpleLink,
    isSimpleLink = _ref$isSimpleLink === void 0 ? false : _ref$isSimpleLink,
    dataId = _ref.dataId,
    wrapProps = _objectWithoutProperties(_ref, _excluded);
  var typeValue = useMedia(breakpoints, type);
  var typeClass = styles["isType".concat(toTitleCase(typeValue))];
  var weightClass = styles["isWeight".concat(toTitleCase(weight))];
  var spacingClass = styles["isSpacing".concat(toTitleCase(spacing))];
  var isWrapped = isLink || wrapProps.href || wrapProps.to;
  var Tag = tag;
  return /*#__PURE__*/React.createElement(Tag, _objectSpread({
    className: cx(styles.component, typeClass, weightClass, spacingClass, (_cx2 = {}, _defineProperty(_cx2, styles.isItalic, isItalic), _defineProperty(_cx2, styles.isUppercase, isUppercase), _cx2)),
    "data-qa": "text",
    "data-id": dataId
  }, isWrapped ? {} : wrapProps), isWrapped ? /*#__PURE__*/React.createElement(TextLink, _objectSpread({
    isSimpleLink: isSimpleLink
  }, wrapProps), children) : children);
};
Text.types = types;
Text.weights = weights;
Text.spacings = spacings;
Text.tags = tags;
Text.presets = presets;
Text.Link = TextLink;
Text.Strong = TextStrong;
Text.Link1 = function (_ref2) {
  var tag = _ref2.tag,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.LINK), {}, {
    tag: tag
  }));
};
Text.Link1.displayName = 'Link1';
Text.J1 = function (_ref3) {
  var tag = _ref3.tag,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.J1), {}, {
    tag: tag
  }));
};
Text.J1.displayName = 'J1';
Text.J2 = function (_ref4) {
  var tag = _ref4.tag,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.J2), {}, {
    tag: tag
  }));
};
Text.J2.displayName = 'J2';
Text.J3 = function (_ref5) {
  var tag = _ref5.tag,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.J3), {}, {
    tag: tag
  }));
};
Text.J3.displayName = 'J3';
Text.J4 = function (_ref6) {
  var tag = _ref6.tag,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.J4), {}, {
    tag: tag
  }));
};
Text.J4.displayName = 'J4';
Text.H1 = function (_ref7) {
  var tag = _ref7.tag,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.H1), {}, {
    tag: tag || presets.H1.tag
  }));
};
Text.H1.displayName = 'H1';
Text.H2 = function (_ref8) {
  var tag = _ref8.tag,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.H2), {}, {
    tag: tag || presets.H2.tag
  }));
};
Text.H2.displayName = 'H2';
Text.H3 = function (_ref9) {
  var tag = _ref9.tag,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.H3), {}, {
    tag: tag || presets.H3.tag
  }));
};
Text.H3.displayName = 'H3';
Text.H4 = function (_ref10) {
  var tag = _ref10.tag,
    props = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.H4), {}, {
    tag: tag || presets.H4.tag
  }));
};
Text.H4.displayName = 'H4';
Text.H5 = function (_ref11) {
  var tag = _ref11.tag,
    props = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.H5), {}, {
    tag: tag || presets.H5.tag
  }));
};
Text.H5.displayName = 'H5';
Text.H6 = function (_ref12) {
  var tag = _ref12.tag,
    props = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.H6), {}, {
    tag: tag || presets.H6.tag
  }));
};
Text.H6.displayName = 'H6';
Text.Body1 = function (_ref13) {
  var tag = _ref13.tag,
    props = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BODY1), {}, {
    tag: tag || presets.BODY1.tag
  }));
};
Text.Body1.displayName = 'Body1';
Text.Body2 = function (_ref14) {
  var tag = _ref14.tag,
    props = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BODY2), {}, {
    tag: tag || presets.BODY2.tag
  }));
};
Text.Body2.displayName = 'Body2';
Text.Body3 = function (_ref15) {
  var tag = _ref15.tag,
    props = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BODY3), {}, {
    tag: tag || presets.BODY3.tag
  }));
};
Text.Body3.displayName = 'Body3';
Text.Body4 = function (_ref16) {
  var tag = _ref16.tag,
    props = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BODY4), {}, {
    tag: tag || presets.BODY4.tag
  }));
};
Text.Body4.displayName = 'Body4';
Text.Body5 = function (_ref17) {
  var tag = _ref17.tag,
    props = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BODY5), {}, {
    tag: tag || presets.BODY5.tag
  }));
};
Text.Body5.displayName = 'Body5';
Text.Body6 = function (_ref18) {
  var tag = _ref18.tag,
    props = _objectWithoutProperties(_ref18, _excluded18);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BODY6), {}, {
    tag: tag || presets.BODY6.tag
  }));
};
Text.Body6.displayName = 'Body6';
Text.Button1 = function (_ref19) {
  var tag = _ref19.tag,
    props = _objectWithoutProperties(_ref19, _excluded19);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BUTTON1), {}, {
    tag: tag
  }));
};
Text.Button1.displayName = 'Button1';
Text.Button2 = function (_ref20) {
  var tag = _ref20.tag,
    props = _objectWithoutProperties(_ref20, _excluded20);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.BUTTON2), {}, {
    tag: tag
  }));
};
Text.Button2.displayName = 'Button2';
Text.Caption = function (_ref21) {
  var tag = _ref21.tag,
    props = _objectWithoutProperties(_ref21, _excluded21);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.CAPTION), {}, {
    tag: tag
  }));
};
Text.Caption.displayName = 'Caption';
Text.Overline = function (_ref22) {
  var tag = _ref22.tag,
    props = _objectWithoutProperties(_ref22, _excluded22);
  return /*#__PURE__*/React.createElement(Text, _objectSpread(_objectSpread(_objectSpread({}, props), presets.OVERLINE), {}, {
    tag: tag
  }));
};
Text.Overline.displayName = 'Overline';
export default Text;